import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/http/api.service';
import { ImageService } from '@app/core/http/image.service';
import { IOcbAdministrator } from '@app/core/models';
import { MsalService } from '@azure/msal-angular';
import { environment } from '@env/environment';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class AuthenticationService extends ApiService {

    private options = {
        headers: this.defaultHeaders,
        observe: 'body' as 'body',
    };

    constructor(httpClient: HttpClient, private msal: MsalService, private imageService: ImageService) {
        super(httpClient);
    }

    public logout(): any {
        this.msal.logout();
    }

    public get isAuthenticated(): boolean {
        try {
            return !!this.msal.instance.getActiveAccount();
        } catch (error) {
            return false;
        }
    }

    /**
     * Get the current user profile
     */
    public getUserProfile(): Observable<IOcbAdministrator> {
        const profileUrl = `${environment.api.endpoint}/Me`;
        return this.httpClient.get<IOcbAdministrator>(profileUrl, this.options).pipe(
            mergeMap(admin => {

                return forkJoin([
                    this.httpClient.get(`https://graph.microsoft.com/beta/me`),
                    this.imageService.get().pipe(
                        catchError(_ => of('../../assets/images/no-user-photo.jpg')),
                    ),
                ])
                .pipe(map((data: any[]) => {
                    admin.user.properties = data[0];
                    admin.user.photo = data[1];
                    return admin;
                }));

            }),
        );
    }
}
